export default __webpack_public_path__ + "static/media/Cars_17.fb489a05.png";